import { api } from './axios';

function erro(err) {
  const data = err.response ? err.response.data : { message: 'Erro de conexão.' };
  return { result: false, data, status: err.response ? err.response.status : 0 };
}

// ---------------------------------------------------------------------------
// Fluxo público do médico (sem login, protegido por token de convite)
// ---------------------------------------------------------------------------

// Valida o token do convite. Retorna { valid, email, clinics }.
export const validateInvite = async (token) => {
  try {
    const res = await api.get(
      `/api/accounts/medicregistration/invite/validate`,
      { params: { token } }
    );
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// Após o consentimento LGPD: identifica o médico pelo CPF. Se já for
// cadastrado, devolve os dados para o formulário abrir preenchido.
export const identifyByCpf = async (token, cpf) => {
  try {
    const res = await api.post(`/api/accounts/medicregistration/identify`, {
      token,
      cpf,
      lgpd_consent: true,
    });
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// Envia o cadastro preenchido, com a imagem da assinatura.
export const submitRegistration = async (token, formValues, signatureFile) => {
  try {
    const formData = new FormData();
    formData.append('token', token);
    formData.append('lgpd_consent', 'true');
    Object.keys(formValues).forEach((key) => {
      const valor = formValues[key];
      if (valor !== undefined && valor !== null && valor !== '') {
        formData.append(key, valor);
      }
    });
    if (signatureFile) {
      formData.append('signature', signatureFile);
    }
    const res = await api.post(
      `/api/accounts/medicregistration/submit`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// Link do e-mail de liberação, onde o médico informa o código do equipamento
// exibido pelo ImagiPACS Uni na primeira execução.
export const validateHwidToken = async (token) => {
  try {
    const res = await api.get(`/api/accounts/hwid/validate`, {
      params: { token },
    });
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

export const submitHwid = async (token, hwid) => {
  try {
    const res = await api.post(`/api/accounts/hwid/submit`, { token, hwid });
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// Gera um link novo de hwid para um medico -- quando ele troca de computador
// ou perde o e-mail original. Devolve a URL para a IMAGI repassar; nao envia
// e-mail sozinho.
export const createHwidLink = async (userId) => {
  try {
    const res = await api.post(`/api/accounts/hwid/${userId}/newlink`);
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// ---------------------------------------------------------------------------
// Uso interno
// ---------------------------------------------------------------------------

// Clínica convida um médico.
export const requestInvite = async (email, clinicIds) => {
  try {
    const res = await api.post(`/api/accounts/medicregistration/invite`, {
      email,
      clinics: clinicIds || [],
    });
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// IMAGI: fila de cadastros aguardando conclusão.
export const listPending = async () => {
  try {
    const res = await api.get(`/api/accounts/medicregistration/pending`);
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// IMAGI: conclui o cadastro (acionado DEPOIS de configurar o PACS).
export const concludeRegistration = async (uuid) => {
  try {
    const res = await api.post(
      `/api/accounts/medicregistration/pending/${uuid}/conclude`
    );
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// IMAGI: descarta um envio feito por engano (não notifica ninguém).
export const discardRegistration = async (uuid, reason) => {
  try {
    const res = await api.post(
      `/api/accounts/medicregistration/pending/${uuid}/discard`,
      { reason }
    );
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

export const getSignature = async (uuid) => {
  try {
    const res = await api.get(
      `/api/accounts/medicregistration/pending/${uuid}/signature`,
      { responseType: 'blob' }
    );
    return { result: true, data: res.data };
  } catch (err) {
    return { result: false, data: null };
  }
};

// IMAGI: licenças por clínica (limite contratado e uso atual).
export const listLicenses = async () => {
  try {
    const res = await api.get(`/api/accounts/medicregistration/licenses`);
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

export const updateLicense = async (clinicId, maxMedics) => {
  try {
    const res = await api.put(
      `/api/accounts/medicregistration/licenses/${clinicId}`,
      { max_medics: maxMedics }
    );
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

// IMAGI: médicos de uma clínica e remoção de vínculo.
export const listClinicMedics = async (clinicId) => {
  try {
    const res = await api.get(
      `/api/accounts/medicregistration/clinics/${clinicId}/medics`
    );
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};

export const unlinkMedic = async (clinicId, userId) => {
  try {
    const res = await api.post(
      `/api/accounts/medicregistration/clinics/${clinicId}/medics/${userId}/unlink`
    );
    return { result: true, data: res.data };
  } catch (err) {
    return erro(err);
  }
};
